module.exports = __webpack_public_path__ + "static/media/messenger.c221c463.svg";